import { render, staticRenderFns } from "./QType1GroupItemPicker.vue?vue&type=template&id=0ff6f92c&scoped=true&"
import script from "./QType1GroupItemPicker.vue?vue&type=script&lang=js&"
export * from "./QType1GroupItemPicker.vue?vue&type=script&lang=js&"
import style0 from "./QType1GroupItemPicker.vue?vue&type=style&index=0&id=0ff6f92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff6f92c",
  null
  
)

export default component.exports